




import type { Cart as NostoCart } from '@nosto/types';
import type { PropType } from '@nuxtjs/composition-api';
// eslint-disable-next-line no-duplicate-imports
import { defineComponent } from '@nuxtjs/composition-api';

import { useNostoCart } from '~/diptyqueTheme/composable/nosto/useNostoCart';
import { mapCart } from '~/diptyqueTheme/helpers/nosto';
import type { Cart } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'NostoCart',
  props: {
    cart: {
      type: Object as PropType<Cart | null>,
      default: null
    }
  },
  setup(props) {
    let nostoCart: NostoCart;

    if (props.cart) {
      nostoCart = mapCart(props.cart);
    }

    useNostoCart(nostoCart);
  }
});
